import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAddCategoryModalOpen: false,
  isAddProductModalOpen: false,
  isEditProductModalOpen: false,
  isEditUserModalOpen: false,
  isSyncModalOpen: false,
  isProductListModalOpen: false,
};

export const modalSlice = createSlice({
  name: 'modal-slice',
  initialState,
  reducers: {
    openAddCategoryModal: (state) => {
      state.isAddCategoryModalOpen = true;
    },
    closeAddCategoryModal: (state) => {
      state.isAddCategoryModalOpen = false;
    },
    openAddProductModal: (state) => {
      state.isAddProductModalOpen = true;
    },
    closeAddProductModal: (state) => {
      state.isAddProductModalOpen = false;
    },
    openEditProductModal: (state) => {
      state.isEditProductModalOpen = true;
    },
    closeEditProductModal: (state) => {
      state.isEditProductModalOpen = false;
    },
    openEditUserModal: (state) => {
      state.isEditUserModalOpen = true;
    },
    closeEditUserModal: (state) => {
      state.isEditUserModalOpen = false;
    },
    openSyncModal: (state) => {
      state.isSyncModalOpen = true;
    },
    closeSyncModal: (state) => {
      state.isSyncModalOpen = false;
    },
    openProductsListModal: (state) => {
      state.isProductListModalOpen = true;
    },
    closeProductsListModal: (state) => {
      state.isProductListModalOpen = false;
    }
  }
});

export const {
  openAddCategoryModal,
  closeAddCategoryModal,
  openAddProductModal,
  closeAddProductModal,
  openEditProductModal,
  closeEditProductModal,
  openEditUserModal,
  closeEditUserModal,
  openSyncModal,
  closeSyncModal,
  openProductsListModal,
  closeProductsListModal
} = modalSlice.actions;

export default modalSlice;
